import { StimulusResourceType } from 'global/constants';

export function getStimulusLabel(type: StimulusResourceType) {
  switch (type) {
    case 'video':
      return 'Video';
    case 'audio':
      return 'Audio';
    case 'document':
      return 'Document';
    case 'e-book':
      return 'eBook (PDF)';
    case 'e-book-interactive':
      return 'eBook (Interactive)';
    case 'guided-research':
      return 'Guided Research';
    case 'interactive':
      return 'Interactive';
    case 'image':
      return 'Image';
    case 'link':
      return 'Link';
    case 'web-tool':
      return 'Web Tool';
    default:
      return '';
  }
}
